import { pbrExt } from './fragments/sheen-fragment.js';
import { _registerPbrExt } from './pbr-flags.js';

function setPbrSheen(mat, sheen) {
  mat._sheen = sheen;
  _registerPbrExt(pbrExt);
}

export { setPbrSheen };
//# sourceMappingURL=set-sheen.js.map
